var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding no-margin"},[(_vm.route == `/employer-advisor/networks`)?_c('Networks'):_vm._e(),(_vm.route == `/employer-advisor/networks/builder`)?_c('NetworkBuilder'):_vm._e(),(_vm.route == `/employer-advisor/networks/network`)?_c('Network'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }